import { render, staticRenderFns } from "./RetrievePasswordDialog.vue?vue&type=template&id=5df71be5&scoped=true&"
import script from "./RetrievePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./RetrievePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./RetrievePasswordDialog.vue?vue&type=style&index=0&id=5df71be5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df71be5",
  null
  
)

export default component.exports